import {Injectable} from '@angular/core';
import {BaseReactiveStore} from "../../shared/base-reactive-store";
import {ApiErrorDto} from "./models/api-error";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";

export class ApiErrorServiceState {
  errorStack: Array<ApiErrorDto> = new Array<ApiErrorDto>()
}

@Injectable({
  providedIn: 'root'
})
export class ApiErrorService extends BaseReactiveStore<ApiErrorServiceState> {

  $errors: Observable<Array<ApiErrorDto>> = this.select(state => state.errorStack)
  $hasErrors: Observable<boolean> = this.select(state => state.errorStack.length > 0)


  constructor() {
    super(new ApiErrorServiceState())

    if (!environment.production) {
      this.$errors.subscribe(value => {
        console.log('Error from api received/acknowledged! e.count: ' + value.length)
      })

      this.$hasErrors.subscribe(value => {
        console.log('Error' + value ? ' received' : ' acknowledged')
      })
    }

  }

  public addError(err: ApiErrorDto): void {
    const stack = this.state.errorStack;
    stack.push(err)
    this.setState({errorStack: stack})
  }

  public AcknowledgeErrors(action: 'NONE' | 'RELOAD'): void {
    this.setState({errorStack: new Array<ApiErrorDto>()})
    if (action === 'RELOAD') {
      window.location.reload()
    }
  }
}
